export enum UiContainerSpalte {
  SPALTE_RECHTS = 'SpalteRechts',
  SPALTE_LINKS = 'SpalteLinks'
}
